import { get, isString } from "lodash";

const browserExtensionPattern = /-extension:\/\/|webkit-masked-url:\/\/|runtime\.sendMessage\(\)/;

export function isBrowserExtensionError(error: unknown): boolean {
  return browserExtensionPattern.test(`${get(error, "stack")} ${get(error, "message")}`);
}

const stackUrlPattern = /https?:\/\/[^\s()<>]+/g;

export function isForeignScriptError(error: unknown): boolean {
  const stack: unknown = get(error, "stack");
  const urls = isString(stack) ? (stack.match(stackUrlPattern) ?? []) : [];
  return urls.length > 0 && !urls.some((url) => url.includes("/assets/"));
}
